<!-- if you are using compnents, add them here -->
<!-- <app-template *ngIf="stateService.selected.component == 'template'"></app-template> -->
<!-- if you are using anular router us this outlet -->
<router-outlet></router-outlet>
